import { render, staticRenderFns } from "./Alerts.html?vue&type=template&id=07f0c193&scoped=true&"
import script from "./Alerts.js?vue&type=script&lang=js&"
export * from "./Alerts.js?vue&type=script&lang=js&"
import style0 from "./Alerts.scss?vue&type=style&index=0&id=07f0c193&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f0c193",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
